import React, { useEffect, useState } from "react";
import { Select, Spin } from "antd";
import useRequest from "../../hooks/useRequest";
import { ShowToast, Severty } from "../../helper/toast";
import apiPath from "../../constants/apiPath";

const { Option } = Select;

const SubCategorySelect = ({ categoryId, value, onChange, disabled = false, shouldFetch = false }) => {

  const { request } = useRequest();
  const [subCategoryList, setSubCategoryList] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchSubCategories = async () => {
    if (!categoryId) {
      setSubCategoryList([]);
      return;
    }

    setLoading(true);

    request({
      url: `${apiPath.commonSubCategory}/${categoryId}`,
      method: "GET",
      onSuccess: (res) => {
        const subCategories = res?.data?.data || [];
        setSubCategoryList(subCategories);
        setLoading(false);
      },
      onError: (err) => {
        setLoading(false);
        ShowToast(
          err?.response?.data?.message || "Failed to load sub categories",
          Severty.ERROR
        );
      },
    });
  };

  useEffect(() => {
    fetchSubCategories();
  }, [shouldFetch, categoryId]);

  return (
    <Spin spinning={loading} tip="Loading sub categories..." size="small">
      <Select
        showSearch
        allowClear
        placeholder="Select sub category"
        optionFilterProp="children"
        value={value}
        onChange={onChange}
        disabled={disabled}
        loading={loading}
        filterOption={(input, option) =>
          option?.children?.toLowerCase().includes(input.toLowerCase())
        }
        className="w-full"
        style={{ height: 40 }}
      >
        {subCategoryList?.map((item) => (
          <Option key={item._id} value={item._id}>
            {item.en_name}
          </Option>
        ))}
      </Select>
    </Spin>
  );
};

export default SubCategorySelect;
